module.exports = __webpack_public_path__ + "img/3.2038d94a.png";